import { marked } from "marked";
import PreprocessAndRenderLatex from "../../../../components/ProcessRenderLatex";
import { processLatex } from "../../../../utils/PreProcessorLatexCode";
import { normalizeLatexToDoubleDollar } from "../dashboard/teacher/lessons/NewLessons/utils/fileHelpers";

/**
 * Escapes < and > in plain-text parts of an option string,
 * leaving LaTeX blocks (between $$...$$) untouched.
 * Prevents the browser from interpreting e.g. "<class bool>" as an HTML tag.
 */
const prepareOptionContent = (option) => {
  const normalized = normalizeLatexToDoubleDollar(option);
  const parts = normalized.split("$$");
  return parts
    .map((part, i) =>
      i % 2 === 0
        ? part.replace(/</g, "&lt;").replace(/>/g, "&gt;") // text part → escape
        : part                                              // LaTeX block → leave alone
    )
    .join("$$");
};

function MCQs({ options, selectedOption, correct, setSelectedOption }) {
  return (
    <div className="AssingmentMCQs-mock-test-answer-container">
      <div className="options AssingmentMCQs-mock-test-answer-container">
        {options?.map((option, index) => (
          <label
            key={index}
            className={`option AssingmentMCQs-mock-test-answer-folder cursor-pointer ${
              index === selectedOption ? "selected" : ""
            } ${index === correct ? "correct" : ""}`}
          >
            <div style={{ display: "flex" }}>
              <div style={{ paddingRight: "10px" }}>
                {String.fromCharCode(65 + index) + ")"}
              </div>
              {typeof option === "string" ? (
                <PreprocessAndRenderLatex
                  content={prepareOptionContent(option)} // ← was: normalizeLatexToDoubleDollar(option)
                  isBlockMath={false}
                  latexInline={true}
                />
              ) : (
                option
              )}
            </div>
            <input
              type="radio"
              name="questionOption"
              value={index}
              checked={selectedOption === index}
              onChange={() => setSelectedOption(index)}
            />
          </label>
        ))}
      </div>
    </div>
  );
}

export default MCQs;